import type { IconData } from '@stacksjs/iconify-core'

export const businessProductsMoney: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 6.1V4.57H1.52V6.1H0v19.81h1.52v1.52h28.95v-1.52H32V6.1Zm0 16.76h-1.52v1.52h-1.52v1.53H4.57v-1.53H3.05v-1.52H1.52V9.15h1.53V7.62h1.52V6.1h22.86v1.52h1.52v1.53h1.52Z\"/><path fill=\"currentColor\" d=\"M22.86 12.19h1.52v7.62h-1.52Zm-1.53 7.62h1.53v1.53h-1.53Zm0-9.14h1.53v1.52h-1.53Zm-1.52 10.67h1.52v1.52h-1.52Zm0-12.19h1.52v1.52h-1.52Zm-1.53 7.61h1.53v1.53h-1.53Zm-6.09 6.1h7.62v1.52h-7.62Zm1.52-7.62h4.57v1.52h-4.57Zm0 3.05v1.52h1.53v1.53h1.52v-1.53h1.52v-1.52zm4.57-4.57v-1.53h-1.52v-1.52h-1.52v1.52h-1.53v1.53zm-6.09-6.1h7.62v1.53h-7.62Zm0 6.1h1.52v1.52h-1.52Zm-1.53 7.62h1.53v1.52h-1.53Zm0-12.19h1.53v1.52h-1.53ZM9.14 19.81h1.52v1.53H9.14Zm0-9.14h1.52v1.52H9.14Zm-1.52 1.52h1.52v7.62H7.62Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default businessProductsMoney
